export default [
    {
        name: 'Стандартная',
        colors: {
            bg: '#f8fafc',
            text: '#0f172a',
            accent: '#0ABAB5',
        },
    },
    {
        name: 'Классическая',
        colors: {
            bg: '#f8fafc',
            text: '#0e172a',
            accent: '#0a6bcb',
        },
    },
    {
        name: 'Летний закат',
        colors: {
            bg: '#faf5eb',
            text: '#422420',
            accent: '#FF6F61',
        },
    },
    {
        name: 'Лесная гармония',
        colors: {
            bg: '#eef8f3',
            text: '#214f35',
            accent: '#2E8B57',
        },
    },
    {
        name: 'Лавандовый раф',
        colors: {
            bg: '#F9F6FF',
            text: '#585181',
            accent: '#9A8FDD',
        },
    },
    {
        name: 'Песчаные дюны',
        colors: {
            bg: '#fbf5ee',
            text: '#615039',
            accent: '#D2B48C',
        },
    },
    {
        name: 'Арктический лед',
        colors: {
            bg: '#f4fafc',
            text: '#2d4b56',
            accent: '#3f9db8',
        },
    },
    {
        name: 'Клубника',
        colors: {
            bg: '#FFF0F5',
            text: '#673742',
            accent: '#FF6F91',
        },
    },
    {
        name: 'Золотой закат',
        colors: {
            bg: '#FFF9EE',
            text: '#685D22',
            accent: '#FFAA00',
        },
    },
    {
        name: 'Городские огни',
        colors: {
            bg: '#F5F5F5',
            text: '#60430f',
            accent: '#FFA500',
        },
    },
    {
        name: 'Лунная ночь',
        colors: {
            bg: '#F5F5F5',
            text: '#4c3f58',
            accent: '#6C5B7B',
        },
    },
]
